export const milestoneTaskBoardStatusConstants = [
  { name: "Not Started", value: "not_started", variant: "gradient-danger", badgeVariant: "light-danger" },
  { name: "On Going", value: "on_going", variant: "gradient-warning", badgeVariant: "light-warning" },
  { name: "Finished", value: "finished", variant: "gradient-success", badgeVariant: "light-success" },
];
